import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative py-16 md:py-24 lg:py-32 px-4 overflow-hidden bg-cream watermark-bg" data-id="element-125">
      <div className="max-w-6xl mx-auto" data-id="element-126">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-127">
          {/* Left: Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-128">
            <span className="inline-block text-gold font-bold text-xs md:text-sm tracking-[0.2em] uppercase mb-6" data-id="element-129">
              For the person awake at 2:00 AM rehearsing a decision...
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-[3.4rem] font-bold leading-[1.12] mb-6 text-navy" data-id="element-130">
              Stop Guessing If It's God Or Just Your Fear.{' '}
              <span className="text-gold" data-id="element-131">
                Gain Absolute Clarity In Your Relationship In 5 Minutes.
              </span>
            </h1>

            <p className="text-lg md:text-xl text-navy/70 mb-10 leading-relaxed max-w-xl" data-id="element-132">
              Use the "3-Filter Framework" (Body + Fruit + Timing) to
              distinguish Holy Spirit peace from attachment anxiety. Faith-based
              discernment for mature adults.
            </p>

            <CTAButton mainText="YES, I WANT CLARITY NOW — $17.95" large data-id="element-133" />

            <div className="flex flex-wrap items-center gap-x-6 gap-y-3 mt-8 text-sm text-navy/50" data-id="element-134">
              <span className="flex items-center gap-2" data-id="element-135">
                <svg className="w-4 h-4 text-gold" fill="currentColor" viewBox="0 0 20 20" data-id="element-136">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-137" />
                </svg>
                Instant PDF Download
              </span>
              <span className="flex items-center gap-2" data-id="element-138">
                <svg className="w-4 h-4 text-gold" fill="currentColor" viewBox="0 0 20 20" data-id="element-139">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-140" />
                </svg>
                30-Day Money-Back Guarantee
              </span>
              <span className="flex items-center gap-2" data-id="element-141">
                <svg className="w-4 h-4 text-gold" fill="currentColor" viewBox="0 0 20 20" data-id="element-142">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-143" />
                </svg>
                Complete Toolkit Included
              </span>
            </div>
          </motion.div>

          {/* Right: Book Mockup */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative flex justify-center lg:justify-end" data-id="element-144">
            <div className="relative" data-id="element-145">
              <div className="absolute -inset-10 bg-gold/5 rounded-full blur-3xl" data-id="element-146"></div>
              <img src="https://cdn.magicpatterns.com/uploads/kiAQbGqfKoJpkvTdiCXb7G/Is_This_God_or_My_Fear_-_Landing_Page_-_Imagen_01_-_C_(1).png" alt="Is This God or My Fear? — Relationship Edition: Peace vs. Attachment — Book and tablet mockup" className="relative w-full max-w-lg h-auto rounded-2xl shadow-2xl" data-id="element-147" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}